var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var FlagFilled = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M6,5 L17.5,5 C17.5776225,5 17.6541791,5.01807255 17.7236068,5.0527864 C17.970596,5.17628103 18.0707082,5.47661755 17.9472136,5.7236068 L16.059017,9.5 L17.9472136,13.2763932 C17.9819275,13.3458209 18,13.4223775 18,13.5 C18,13.7761424 17.7761424,14 17.5,14 L7,14 L7,20 L6,20 L6,5 Z" })));
};
FlagFilled.displayName = 'FlagFilled';
export default FlagFilled;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=FlagFilled.js.map